//伪造测试数据
const devices=[
    {
        "deviceId": "37010200491320000001",
        "name": "浪潮仓外",
        "manufacturer": "Hikvision",
        "model": "iDS-2DE7223IX-A/S1",
        "firmware": "V5.5.23",
        "transport": "TCP",
        "host": {
            "ip": "10.200.64.194",
            "port": 58206,
            "address": "10.200.64.194:58206"
        },
        "online": 1,
        "channelMap": {
            "37010200491320000001": {
                "channelId": "37010200491320000001",
                "name": "济南第一粮库大门",
                "manufacture": "Hikvision",
                "model": "IP Camera",
                "owner": "Owner",
                "civilCode": "CivilCode",
                "block": null,
                "address": "Address",
                "parental": 0,
                "parentId": null,
                "safetyWay": 0,
                "registerWay": 1,
                "certNum": null,
                "certifiable": 0,
                "errCode": 0,
                "endTime": null,
                "secrecy": "0",
                "ipAddress": null,
                "port": 0,
                "password": null,
                "status": 1,
                "longitude": 0.0,
                "latitude": 0.0
            }
        }
    },
    {
        "deviceId": "34020000001320000004",
        "name": null,
        "manufacturer": "Dahua",
        "model": "DH-SD-59D120T-HN",
        "firmware": "V2.422.3.R.2016-11-30",
        "transport": "UDP",
        "host": {
            "ip": "10.200.64.195",
            "port": 5060,
            "address": "10.200.64.195:5060"
        },
        "online": 0,
        "channelMap": {
            "34020000001320000004": {
                "channelId": "34020000001320000004",
                "name": "Camera 01",
                "manufacture": "Dahua",
                "model": "DH-SD-59D120T-HN",
                "owner": "0",
                "civilCode": "6532",
                "block": null,
                "address": "axy",
                "parental": 0,
                "parentId": null,
                "safetyWay": 0,
                "registerWay": 1,
                "certNum": null,
                "certifiable": 0,
                "errCode": 0,
                "endTime": null,
                "secrecy": "0",
                "ipAddress": null,
                "port": 0,
                "password": null,
                "status": 1,
                "longitude": 0.0,
                "latitude": 0.0
            },
			"34020000001320000005": {
			    "channelId": "34020000001320000005",
			    "name": "Camera 011",
			    "manufacture": "Dahua1",
			    "model": "DH-SD-59D120T-HN",
			    "owner": "0",
			    "civilCode": "6532",
			    "block": null,
			    "address": "axy1",
			    "parental": 0,
			    "parentId": null,
			    "safetyWay": 0,
			    "registerWay": 1,
			    "certNum": null,
			    "certifiable": 0,
			    "errCode": 0,
			    "endTime": null,
			    "secrecy": "0",
			    "ipAddress": null,
			    "port": 0,
			    "password": null,
			    "status": 1,
			    "longitude": 0.0,
			    "latitude": 0.0
			}
        }
    }
]

const recordData={
    "deviceId": "34020000001320000001",
    "name": "假数据中化梁抵库",
    "sumNum": 2,
    "recordList": [
        {
            "deviceId": "34020000001320000001",
            "name": "假数据中化梁抵库",
            "filePath": "1589112259_1589112788",
            "address": "Address 1",
            "startTime": "2020-05-10 20:04:19",
            "endTime": "2020-05-10 20:13:08",
            "secrecy": 0,
            "type": "time",
            "recorderId": null
        },
        {
            "deviceId": "34020000001320000001",
            "name": "假数据中化梁抵库",
            "filePath": "1589112788_1589113318",
            "address": "Address 1",
            "startTime": "2020-05-10 20:13:08",
            "endTime": "2020-05-10 20:21:58",
            "secrecy": 0,
            "type": "time",
            "recorderId": null
        }
    ]
}

export default{
	devices,//设备列表
	recordData,
}